import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/webapp/src/app/global-error.tsx");
